'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styles = {
  "ScrollContainer": "Polaris-IndexTable-ScrollContainer"
};

exports.default = styles;
